export const NameSpace = {
  DATA: `DATA`,
  APPLICATION: `APPLICATION`,
};
